import type { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";

export const REFERRAL_COOKIE = "lootstack-ref";

export function setReferralCookie(code: string, citySlug?: string): void {
  const value = citySlug ? `${code}:${citySlug}` : code;
  document.cookie = `${REFERRAL_COOKIE}=${value}; path=/; max-age=2592000; SameSite=Lax`;
}

export function getReferralFromCookies(
  cookieStore: ReadonlyRequestCookies
): { code: string; citySlug: string } | null {
  const value = cookieStore.get(REFERRAL_COOKIE)?.value;
  if (!value) return null;

  const colonIndex = value.indexOf(":");
  if (colonIndex === -1) {
    return { code: value, citySlug: "" };
  }

  const code = value.slice(0, colonIndex);
  const citySlug = value.slice(colonIndex + 1);
  if (!code || !citySlug) return null;

  return { code, citySlug };
}

export function clearReferralCookie(
  cookieStore: ReadonlyRequestCookies
): void {
  cookieStore.delete(REFERRAL_COOKIE);
}
